import { INew_TableAction, ITimePeriodWithLocationIds } from '@lla-platform/core/core-data-access'
import { ICallIntelligenceLeadAnalysisRequest } from '../../interfaces/call-intelligence-details.interface'
import { IRetagCallsRequest, IUpsertCallTagRequest } from '../../interfaces/call-tag.interface'

export class GetCallIntelligenceDashboard {
  static readonly type = '[callIntelligence] GetCallIntelligenceDashboard'
  constructor(public payload: ITimePeriodWithLocationIds) {}
}

export class GetCallIntelligenceDrilldown {
  static readonly type = '[callIntelligence] Get Call Intelligence Drilldown'
  constructor(public payload: ITimePeriodWithLocationIds) {}
}

export class GetCallIntelligenceLeadsList {
  static readonly type = '[callIntelligence] Get Leads List'
  constructor(public info: INew_TableAction) {}
}

export class GetCallIntelligenceLeadDetails {
  static readonly type = '[callIntelligence] Get Lead Details'
  constructor(public id: string) {}
}

export class LinkCallIntelligenceLeadContact {
  static readonly type = '[callIntelligence] Link Lead Contact'
  constructor(
    public leadId: string,
    public contactId: string
  ) {}
}

export class UnlinkCallIntelligenceLeadContact {
  static readonly type = '[callIntelligence] Unlink Lead Contact'
  constructor(public leadId: string) {}
}

export class MarkCallIntelligenceLeadReviewed {
  static readonly type = '[callIntelligence] Mark Lead Reviewed'
  constructor(public id: string) {}
}

export class ReProcessCallIntelligenceLead {
  static readonly type = '[callIntelligence] ReProcess Lead'
  constructor(
    public id: string,
    public message: string
  ) {}
}

export class EditCallIntelligenceLeadAnalysis {
  static readonly type = '[callIntelligence] Edit Lead Analysis'
  constructor(
    public id: string,
    public request: ICallIntelligenceLeadAnalysisRequest
  ) {}
}

export class GetCallIntelligenceLeadAnalysisVersions {
  static readonly type = '[callIntelligence] Get Lead Analysis Versions'
  constructor(public id: string) {}
}

export class GetActiveCallTags {
  static readonly type = '[callIntelligence] Get Active Call Tags'
}

export class GetCallTags {
  static readonly type = '[callIntelligence] Get Call Tags'
}

export class CreateCallTag {
  static readonly type = '[callIntelligence] Create Call Tag'
  constructor(public payload: IUpsertCallTagRequest) {}
}

export class UpdateCallTag {
  static readonly type = '[callIntelligence] Update Call Tag'
  constructor(
    public id: string,
    public payload: IUpsertCallTagRequest
  ) {}
}

export class DeleteCallTag {
  static readonly type = '[callIntelligence] Delete Call Tag'
  constructor(public id: string) {}
}

export class RetagCalls {
  static readonly type = '[callIntelligence] Retag Calls'
  constructor(public payload: IRetagCallsRequest) {}
}

export class GetFilteredCallTags {
  static readonly type = '[callIntelligence] Get Filtered Call Tags'
  constructor(public payload: INew_TableAction) {}
}
